function checkScreenWidth() {
  const homePinkSection = document.getElementById("shopify-section-template--16274261967038__1c2d2914-fd37-4b90-aade-aab9d08b47d9");
  const homePinkSectionBlocks = homePinkSection.querySelector(".rich-text__blocks");
  const customerStoriesLogos = document.querySelectorAll(".customer-stories-logos");
  
  if (window.innerWidth <= 749) {
    // MOBILE: Position before button
    const lastChild = homePinkSectionBlocks.lastElementChild;
    if (lastChild && lastChild.previousElementSibling) {
      homePinkSectionBlocks.insertBefore(customerStoriesLogos[0], lastChild);
    } else {
      homePinkSectionBlocks.appendChild(customerStoriesLogos[0]);
    }
  } else {
    // DESKTOP: Position after button
    homePinkSectionBlocks.appendChild(customerStoriesLogos[0]);
  }
}

// document.addEventListener("DOMContentLoaded", checkScreenWidth);
// window.addEventListener('resize', checkScreenWidth);